module.exports = __webpack_public_path__ + "static/media/DepIcon.6bd73041.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/icons/DepIcon.svg
// module id = 710
// module chunks = 0